import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerStmtRezService } from '../owner-stmt-rez.service';
import { OwnerStmtRez } from '../owner-stmt-rez';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-owner-stmt-rez',
    templateUrl: './owner-stmt-rez.component.html',
    styleUrls: ['./owner-stmt-rez.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerStmtRezComponent implements OnInit {

  properties: any;
  ownerStmtId: any;
  ownerStmtIdRequired: boolean;

  constructor(
    private propertyService: PropertyService,
    private primengConfig: PrimeNGConfig,
    private ownerStmtRezService: OwnerStmtRezService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title,
    this.ownerStmtId = data.ownerStmtId,
      this.ownerStmtRez = data.ownerStmtRez,
      this.statuses = ownerStmtRezService.statuses;
  }

  @Input() ownerStmtRez: OwnerStmtRez;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  ownerStmtRezId: number;
  

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    'ownerStmtRezId': [],
    'rezConfId': [{ type: 'required', message: 'Please enter only Alphanumeric' }],
    'guestName': [],
    'checkInDate': [],
    'checkOutDate': [],
    'numNights': [],
    'ownerNotes': [],
    'opsNotes': [],
    'reservationId': [],
    'ownerStmtId':[] //ParentId here
  };

  ngOnInit() {
    this.fetchProperties();
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole ownerStmt object
    if (this.ownerStmtRez) {
      this.ownerStmtRezId = this.ownerStmtRez.ownerStmtRezId;
      this.fixDates();
      this.form1.patchValue(this.ownerStmtRez);
    }
  }

  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.ownerStmtRezId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete()
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }

				this.form1.value.ownerStmtId = this.ownerStmtId;


      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.ownerStmtRezService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.ownerStmtRez = res.data.ownerStmtRez;
            this.doAdd.emit(this.ownerStmtRez);
          },
          (err: any) => {
            console.log('ownerStmtRez-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('ownerStmtRez: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
    //  this.form1.value.ownerStmtId = this.ownerStmtId;
      this.ownerStmtRezService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.ownerStmtRez = res.data.ownerStmtRez;
            this.doUpdate.emit(this.ownerStmtRez);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.ownerStmtRezService.delete(this.ownerStmtRez.ownerStmtRezId)
        .subscribe(
          (res: any) => {
            console.log('ownerStmtRez-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.ownerStmtRez);
          },
          (err: any) => {
            console.log('ownerStmtRez-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      ownerStmtRezId: [this.ownerStmtRezId],
      rezConfId: ['', Validators.required],
      guestName: [],
      checkInDate: [],
      checkOutDate: [],
      numNights: [],
      ownerNotes: [],
      opsNotes: [],
      reservationId: [],
      assignedTo: [],
      ownerStmtId: [this.ownerStmtId]
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.ownerStmtRez.ownerStmtRezDate = moment(this.ownerStmtRez.ownerStmtRezDate).toDate();
  }

  fetchProperties() {
    if (!this.properties || this.properties === undefined || this.properties.length < 1) {
      try {
        this.propertyService.findAllSummary()
          .subscribe(
            res => {
              // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
              this.properties = res.data.properties;
              return this.properties;
            },
            err => {
              console.log('Feature-Update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      // console.log('properties are ' + this.properties);
      return (this.properties);
    }
  }

  selectOwnerStmtRez(){
		this.ownerStmtIdRequired = false;
	}
}

